module.exports = __webpack_public_path__ + "media/components/assets/icons/arrow_r_white-469d4175689750ad4310a55044842394.svg";